<vectronic-card title="Add Template" [displayClose]="true" (closed)="dialogRef.close()">
  <ng-container body>
    <div class="schedule-template-modal__content">
      <rc-edit-schedule-template
        [scheduleTemplate]="data?.scheduleTemplate"
        [hideCustomerVisibility]="data?.hideCustomerVisibility ?? false"
        [hideUserId]="data?.hideUserId ?? false"
        [hasHighActivityCameraTrigger]="true"
        buttonLabel="Create"
        buttonIcon="send"
        (save)="onSave($event)"
      ></rc-edit-schedule-template>

      @if (gpsXFileImportService.loading()) {
        <div class="schedule-template-modal__loading-overlay">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      }
    </div>
  </ng-container>
</vectronic-card>
